const ServicesGrid = () => {
  const services = [
    {
      icon: 'ri-oil-line',
      title: 'Oil & Gas Exploration Technology',
      description: 'Advanced R&D solutions for oil and gas exploration and development, providing cutting-edge technologies to optimize resource discovery and extraction efficiency.',
      features: ['Seismic Data Analysis', 'Reservoir Modeling', 'Drilling Optimization', 'Production Enhancement']
    },
    {
      icon: 'ri-dashboard-line',
      title: 'Industrial Intelligent Monitoring',
      description: 'Smart monitoring systems for industrial operations, leveraging IoT and AI technologies to ensure safety, efficiency, and predictive maintenance.',
      features: ['Real-time Monitoring', 'Predictive Analytics', 'Safety Management', 'Performance Optimization']
    },
    {
      icon: 'ri-code-box-line',
      title: 'Software Development',
      description: 'Custom software solutions tailored to your business needs, from enterprise applications to specialized industry software with robust architecture.',
      features: ['Enterprise Solutions', 'Cloud Applications', 'System Integration', 'Technical Support']
    },
    {
      icon: 'ri-settings-3-line',
      title: 'OEM for New Products & Technologies',
      description: 'Professional OEM services for innovative products and technologies, providing comprehensive manufacturing and quality assurance solutions.',
      features: ['Custom Manufacturing', 'Quality Assurance', 'Technology Transfer', 'Supply Chain Management']
    }
  ];

  const industries = [
    { name: 'Oil & Gas', icon: 'ri-oil-line' },
    { name: 'Smart Monitoring', icon: 'ri-dashboard-line' },
    { name: 'Software Development', icon: 'ri-code-box-line' },
    { name: 'Intelligent Manufacturing', icon: 'ri-settings-3-line' }
  ];

  return (
    <section className="py-32 bg-gradient-to-b from-slate-800/30 to-slate-900/30 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-20 left-10 w-72 h-72 bg-blue-600/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-cyan-600/5 rounded-full blur-3xl"></div>
      </div>

      <div className="relative container mx-auto px-6">
        {/* Core Services */}
        <div className="text-center mb-20">
          <div className="inline-block mb-6">
            <span className="px-4 py-2 bg-blue-600/20 text-blue-300 rounded-full text-sm font-medium border border-blue-400/30">
              Core Business Areas
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-light text-white mb-8 leading-tight">
            Professional <strong className="bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent">Solutions</strong>
          </h2>
          <p className="text-lg text-white/80 max-w-3xl mx-auto font-light leading-relaxed">
            Specialized expertise in energy technology, industrial intelligence, and innovative manufacturing solutions
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-24 max-w-7xl mx-auto">
          {services.map((service, index) => (
            <div
              key={index}
              className="group relative"
            >
              <div className="absolute inset-0 bg-gradient-to-r from-blue-600/10 to-cyan-600/10 rounded-3xl blur-xl group-hover:blur-2xl transition-all duration-500"></div>
              <div className="relative bg-white/8 backdrop-blur-md rounded-3xl p-8 border border-white/20 hover:border-blue-400/40 transition-all duration-500 hover:shadow-2xl hover:shadow-blue-500/10 group-hover:bg-white/12 h-full">
                <div className="flex items-start gap-6">
                  <div className="flex-shrink-0">
                    <div className="w-16 h-16 bg-gradient-to-r from-blue-600/30 to-cyan-600/30 rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300 border border-blue-400/30">
                      <i className={`${service.icon} text-3xl text-blue-300`}></i>
                    </div>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-2xl font-semibold text-white mb-4 group-hover:text-blue-100 transition-colors duration-300">
                      {service.title}
                    </h3>
                    <p className="text-white/80 mb-6 leading-relaxed font-light">
                      {service.description}
                    </p>
                    <div className="grid grid-cols-2 gap-3">
                      {service.features.map((feature, idx) => (
                        <div key={idx} className="flex items-center gap-2 group/item">
                          <div className="w-5 h-5 flex items-center justify-center bg-blue-600/20 rounded-lg flex-shrink-0 group-hover/item:bg-blue-600/30 transition-colors duration-300">
                            <i className="ri-check-line text-blue-400 text-xs"></i>
                          </div>
                          <span className="text-sm text-white/70 font-medium group-hover/item:text-white/90 transition-colors duration-300">{feature}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Technology Focus Areas */}
        <div className="text-center mb-16">
          <div className="inline-block mb-6">
            <span className="px-4 py-2 bg-cyan-600/20 text-cyan-300 rounded-full text-sm font-medium border border-cyan-400/30">
              Technology Focus
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-light text-white mb-8 leading-tight">
            Innovation <strong className="bg-gradient-to-r from-cyan-400 to-blue-400 bg-clip-text text-transparent">Areas</strong>
          </h2>
          <p className="text-lg text-white/80 max-w-3xl mx-auto font-light leading-relaxed">
            Specialized expertise across energy, industrial intelligence, and advanced manufacturing sectors
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto">
          {industries.map((industry, index) => (
            <div
              key={index}
              className="group relative"
            >
              <div className="absolute inset-0 bg-gradient-to-r from-cyan-600/10 to-blue-600/10 rounded-3xl blur-xl group-hover:blur-2xl transition-all duration-500"></div>
              <div className="relative bg-white/8 backdrop-blur-md border border-white/20 rounded-3xl overflow-hidden hover:bg-white/12 hover:border-cyan-400/40 transition-all duration-500 hover:transform hover:scale-105">
                {/* 背景图片 */}
                <div className="relative h-48 overflow-hidden">
                  <img 
                    src={getIndustryImageUrl(industry.name, index)}
                    alt={industry.name}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                </div>
                
                {/* 内容区域 */}
                <div className="relative p-8 text-center">
                  <div className="w-20 h-20 mx-auto mb-6 bg-gradient-to-r from-cyan-500/20 to-blue-500/20 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300 border border-cyan-400/30 -mt-16 relative z-10 backdrop-blur-md">
                    <i className={`${industry.icon} text-3xl text-cyan-400`}></i>
                  </div>
                  <h3 className="text-xl font-semibold text-white mb-4 group-hover:text-cyan-100 transition-colors duration-300">{industry.name}</h3>
                  <p className="text-white/80 text-sm leading-relaxed font-light">
                    {getIndustryDescription(industry.name)}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const getIndustryImagePrompt = (industryName: string): string => {
  const prompts: Record<string, string> = {
    'Oil & Gas': 'Modern oil and gas exploration technology with advanced drilling equipment, geological survey instruments, and digital monitoring systems in professional industrial setting with blue lighting and high-tech atmosphere',
    'Smart Monitoring': 'Advanced smart monitoring systems with digital dashboards, real-time data visualization, control room with multiple screens, industrial monitoring equipment, professional technology environment with blue ambient lighting',
    'Software Development': 'Modern software development environment with multiple computer screens showing code, digital interfaces, cloud computing visualization, professional programming workspace with blue technology lighting and futuristic design',
    'Intelligent Manufacturing': 'Advanced intelligent manufacturing facility with automated production lines, AI-powered robotic systems, smart sensors and IoT devices, precision machinery with digital displays, modern industrial environment with blue technology lighting'
  };
  
  return prompts[industryName] || 'Modern technology innovation workspace with advanced equipment, digital displays, and professional blue lighting atmosphere';
};

const getIndustryImageUrl = (industryName: string, index: number): string => {
  const imageUrls: Record<string, string> = {
    'Oil & Gas': `https://public.readdy.ai/ai/img_res/f258d708218ed4226e6f8be4295f9eae.jpg${index}&orientation=landscape`,
    'Smart Monitoring': `https://static.readdy.ai/image/a1246d82218fb65f453dd1e18d26957d/bd86cce8dd7c4f3fd624c62d9b774c04.jpeg`,
    'Software Development': `https://static.readdy.ai/image/a1246d82218fb65f453dd1e18d26957d/24f962a27270d7e141be0689b5185aa2.jpeg`,
    'Intelligent Manufacturing': `https://readdy.ai/api/search-image?query=Modern%20intelligent%20manufacturing%20facility%20with%20advanced%20automated%20production%20lines%20and%20robotic%20systems%2C%20sleek%20blue-toned%20industrial%20environment%20with%20sophisticated%20machinery%20and%20digital%20displays%2C%20high-tech%20factory%20floor%20with%20AI-powered%20equipment%20and%20smart%20sensors%2C%20clean%20minimalist%20design%20with%20premium%20blue%20ambient%20lighting%2C%20futuristic%20manufacturing%20workspace%20showcasing%20cutting-edge%20automation%20technology%20without%20any%20text%20or%20labels&width=400&height=300&seq=blue-smart-manufacturing-${index}&orientation=landscape`
  };
  
  return imageUrls[industryName] || `https://readdy.ai/api/search-image?query=Premium%20technology%20innovation%20workspace%20with%20sophisticated%20equipment%20and%20elegant%20design&width=400&height=300&seq=premium-tech-${index}&orientation=landscape`;
};

const getIndustryDescription = (industryName: string): string => {
  const descriptions: Record<string, string> = {
    'Oil & Gas': 'Advanced petroleum exploration and development technologies with cutting-edge seismic analysis and reservoir optimization solutions',
    'Smart Monitoring': 'Intelligent monitoring systems providing real-time data analytics, predictive maintenance, and comprehensive safety management solutions',
    'Software Development': 'Custom software development services including enterprise applications, cloud platforms, and system integration solutions',
    'Intelligent Manufacturing': 'AI-driven intelligent manufacturing technologies providing automated production lines, smart quality control, and digital factory management'
  };
  
  return descriptions[industryName] || 'Innovative technology solutions empowering digital transformation and intelligent upgrades for enterprises';
};

export default ServicesGrid;
